<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Courses': 'Cursos',
      'Buy': 'Comprar',
      'Pay': 'Pagar',
      'Access': 'Acessar',
    },
    es: {
      'Courses': 'Cursos',
      'Buy': 'Comprar',
      'Pay': 'Pagar',
      'Access': 'Acceder',
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      courses: null,
      buy: {
        modal: false,
        loading: false,
        id: '',
        title: '',
        price: '',
      },
    };
  },
  methods: {
    getCourses() {
      this.courses = null;

      api
        .get('courses')
        .then(response => {
          if (response.data.status == 'success') {
            this.courses = response.data.list
          } else {
            this.courses = []
          }
        })
        .catch(error => {
          if (error) {
            this.courses = []
          }
        })
    },
    showBuy(course) {
      this.buy.modal = false;
      this.buy.modal = true;
      this.buy.id = course.id;
      this.buy.title = course.title;
      this.buy.price = course.price;
    },
    buyCourse() {
      if (this.buy.id) {
        this.buy.loading = true;

        api
          .post('courses/buy', {
            id: this.buy.id
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.$router.push('/courses/order/' + response.data.order.id);
            } else {
              this.$toast.error(response.data.message);
            }
          })
          .catch((error) => {
            if (error) {
              this.buy.modal = false;
              this.buy.loading = false;
            }
          })
          .finally(() => {
            this.buy.modal = false;
            this.buy.loading = false;
          });
      }
    },
    goToOrder(course) {
      this.$router.push('/courses/order/' + course.order.id);
    },
  },
  mounted() {
    this.getCourses()
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Courses') }}</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!courses" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="courses && courses.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          ainda não temos nenhum curso disponível
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-md-4" v-for="(row, index) in courses" :key="index">
          <div class="card">
            <div class="card-body p-2">
              <img v-if="row.cover" class="course-cover" :src="row.cover" />
              <div class="p-2 text-center">
                <h5>{{ row.title }}</h5>
                <h3 v-if="row.price > 0" class="text-dark mb-3">{{ row.price | currency }}</h3>
                <router-link v-if="row.purchased" tag="a" :to="'/courses/' + row.slug" class="btn btn-default btn-lg btn-block text-uppercase">
                  {{ t('Access') }}
                </router-link>
                <button v-else-if="row.pending" class="btn btn-default btn-lg btn-block text-uppercase" v-on:click="goToOrder(row)">
                  {{ t('Buy') }}
                </button>
                <button v-else class="btn btn-default btn-lg btn-block text-uppercase" v-on:click="showBuy(row)">
                  {{ t('Buy') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="buy.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div>
        <h4>Confirmar compra</h4>
        <p>Confirma a compra do curso <strong>{{ buy.title }}</strong> por <strong>{{ buy.price | currency }}</strong>?</p>
        <div class="d-flex justify-content-between">
          <button class="btn btn-default btn-lg mr-3" v-on:click="buyCourse()" :disabled="buy.loading">
            Confirmar
            <b-spinner v-if="buy.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <button class="btn btn-outline-link" v-on:click="buy.modal = false">Fechar <sup>ESC</sup></button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.course-cover {
  border-radius: 5px;
  margin-bottom: 10px;
  width: 100%;
  object-fit: cover;
  aspect-ratio: 10 / 5;
}
</style>
